import { forwardRef, ReactElement } from "react";
import { Dialog, DialogContent, Fade, useTheme } from "@mui/material";

type LocationReportPopperProps = {
  id: number;
  open: boolean;
  onClose: () => void;
  children: ReactElement;
};

/** Above map tiles and other portaled facility-report UI. */
const LOCATION_REPORT_DIALOG_Z_INDEX = 16_000;

export const LocationReportPopper = forwardRef<HTMLDivElement, LocationReportPopperProps>(
  (props, ref) => {
    const { children, id, open, onClose } = props;
    const theme = useTheme();

    return (
      <Dialog
        ref={ref}
        id={String(id)}
        open={open}
        onClose={(_event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            onClose();
          }
        }}
        scroll="paper"
        maxWidth="md"
        fullWidth
        slots={{ transition: Fade }}
        transitionDuration={{ enter: 350, exit: 250 }}
        slotProps={{
          root: {
            "data-testid": "location-report-popper-root",
            sx: { zIndex: LOCATION_REPORT_DIALOG_Z_INDEX }
          },
          paper: {
            sx: {
              maxWidth: 420,
              width: "100%",
              m: { xs: 1, sm: 2 },
              maxHeight: "min(90dvh, 900px)",
              borderRadius: "10px",
              backgroundColor: theme.palette.background.paper,
              boxShadow: theme.shadows[8]
            }
          }
        }}
      >
        <DialogContent sx={{ p: 2 }}>{children}</DialogContent>
      </Dialog>
    );
  }
);

LocationReportPopper.displayName = "LocationReportPopper";
